import { AxiosPromise } from 'axios'
import { createTeamInvitesClient } from './createTeamInvitesClient'
import { deleteInvite, getInvitesByEmail, getInvites, putInvite, postInvite } from './methods'
import { TeamInvitesClientOptions, TeamInvitesClient as BaseTeamInvitesClient } from './types'

export default function TeamInvitesClient(options?: TeamInvitesClientOptions): TeamUserClient {
  const commonOptions = {}

  return createTeamInvitesClient({
    ...commonOptions,
    ...options,
    methods: {
      getInvitesByEmail,
      getInvites,
      postInvite,
      putInvite,
      deleteInvite,
    },
  })
}

export type TeamUserClient = BaseTeamInvitesClient & {
  readonly getInvitesByEmail: (email: string) => AxiosPromise<any>,
  readonly getInvites: () => AxiosPromise<any>,
  readonly postInvite: (invite) => AxiosPromise<any>,
  readonly putInvite: (data) => AxiosPromise<any>,
  readonly deleteInvite: (id) => AxiosPromise<any>,
}
